/* ==========================================================================
   way-out by Clensta — storefront behaviour (no dependencies)
   Modules: theme · progress · flapboard · offer deck · belts · postcards
            cart (Shopify AJAX Cart API) · product form · sticky bar · sort
   ========================================================================== */
(() => {
  'use strict';
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const CFG = window.WayOut || {};
  const routes = {
    add: (CFG.routes && CFG.routes.cart_add_url || '/cart/add') + '.js',
    change: (CFG.routes && CFG.routes.cart_change_url || '/cart/change') + '.js',
    cart: (CFG.routes && CFG.routes.cart_url || '/cart') + '.js',
    checkout: '/checkout'
  };

  /* ── Money ─────────────────────────────────────────────────────────────── */
  const money = (cents, currency) => new Intl.NumberFormat(CFG.locale || 'en-IN', {
    style: 'currency', currency: currency || CFG.currency || 'INR', maximumFractionDigits: cents % 100 ? 2 : 0
  }).format(cents / 100);

  /* ── Theme toggle (dark by default, remembered per visitor) ────────────── */
  function initTheme() {
    const root = document.documentElement;
    try { if (localStorage.getItem('wo-mode') === 'light') root.classList.add('wo-light'); } catch (e) {}
    $$('[data-wo-theme]').forEach(btn => btn.addEventListener('click', () => {
      const light = root.classList.toggle('wo-light');
      try { localStorage.setItem('wo-mode', light ? 'light' : 'dark'); } catch (e) {}
    }));
  }

  /* ── Route progress plane under the header ─────────────────────────────── */
  function initProgress() {
    const fill = $('[data-wo-progress-fill]'), plane = $('[data-wo-progress-plane]');
    if (!fill) return;
    const update = () => {
      const max = document.documentElement.scrollHeight - innerHeight;
      const pct = max > 0 ? Math.min(100, (scrollY / max) * 100) : 0;
      fill.style.width = pct + '%'; if (plane) plane.style.left = pct + '%';
    };
    addEventListener('scroll', update, { passive: true }); update();
  }

  /* ── Split-flap departures board ───────────────────────────────────────── */
  function initFlapboards() {
    const A = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    $$('[data-wo-flapboard]').forEach(board => {
      const flaps = $$('.wo-flap', board);
      const spin = () => flaps.forEach((f, i) => {
        let n = 0; const max = 6 + (i % 9); f.classList.add('is-spinning');
        const t = setInterval(() => {
          f.textContent = A[Math.floor(Math.random() * 26)];
          if (++n > max) { clearInterval(t); f.textContent = f.dataset.t; f.classList.remove('is-spinning'); }
        }, 55);
      });
      if (reduceMotion) return;
      spin();
      const every = parseInt(board.dataset.interval || '7', 10) * 1000;
      if (every > 0) setInterval(() => { if (!document.hidden) spin(); }, every);
    });
  }

  /* ── Offer deck (stack of boarding passes) ─────────────────────────────── */
  function initDecks() {
    $$('[data-wo-deck]').forEach(deck => {
      const cards = $$('.wo-opass', deck), allBars = $$('[data-wo-deck-bars]', deck), idx = $('[data-wo-deck-idx]', deck);
      const n = cards.length; if (!n) return;
      const dur = (parseFloat(deck.dataset.duration) || 5) * 1000;
      deck.style.setProperty('--wo-deck-dur', dur / 1000 + 's');
      let cur = 0, timer = null, paused = false;
      if (allBars.length) {
        allBars.forEach(bars => {
          bars.innerHTML = cards.map((_, i) => `<button type="button" aria-label="Offer ${i + 1}" data-go="${i}"><span></span></button>`).join('');
        });
      }
      const paint = () => {
        cards.forEach((c, i) => {
          const pos = (i - cur + n) % n;
          c.dataset.pos = pos > 2 ? 'hidden' : pos;
          c.tabIndex = pos === 0 ? 0 : -1;
          c.setAttribute('aria-hidden', pos !== 0);
        });
        if (idx) idx.textContent = cur + 1;
        allBars.forEach(bars => {
          $$('button', bars).forEach((b, i) => {
            b.classList.toggle('is-on', i === cur);
            b.classList.remove('is-done');
            b.setAttribute('aria-current', i === cur ? 'true' : 'false');
            const s = b.firstElementChild;
            if (s) { s.style.animation = 'none'; void s.offsetWidth; s.style.animation = ''; }
          });
        });
      };
      const restart = () => { clearTimeout(timer); if (!reduceMotion && !paused && n > 1) timer = setTimeout(() => go(cur + 1, 1), dur); };
      const go = (i, dir) => {
        const nextIdx = (i + n) % n;
        if (nextIdx === cur && n > 1) return;
        const out = cards[cur];
        const inCard = cards[nextIdx];

        cards.forEach(c => {
          c.classList.remove('is-out', 'is-out-back', 'is-in', 'is-in-back');
          c.style.transform = '';
          c.style.transition = '';
        });

        if (dir !== 0) {
          out.classList.add(dir > 0 ? 'is-out' : 'is-out-back');
          inCard.classList.add(dir > 0 ? 'is-in' : 'is-in-back');
        }

        cur = nextIdx;
        paint();
        restart();

        setTimeout(() => {
          out.classList.remove('is-out', 'is-out-back');
          inCard.classList.remove('is-in', 'is-in-back');
        }, 460);
      };
      $('[data-wo-deck-next]', deck)?.addEventListener('click', () => go(cur + 1, 1));
      $('[data-wo-deck-prev]', deck)?.addEventListener('click', () => go(cur - 1, -1));
      allBars.forEach(bars => {
        bars.addEventListener('pointerdown', e => e.stopPropagation());
        bars.addEventListener('mousedown', e => e.stopPropagation());
        bars.addEventListener('touchstart', e => e.stopPropagation(), { passive: true });
        bars.addEventListener('click', e => {
          e.preventDefault();
          e.stopPropagation();
          const b = e.target.closest('[data-go]');
          if (b) {
            const targetIdx = parseInt(b.dataset.go, 10);
            if (!isNaN(targetIdx) && targetIdx !== cur) {
              go(targetIdx, targetIdx > cur ? 1 : -1);
            }
          }
        });
      });
      deck.addEventListener('mouseenter', () => { paused = true; clearTimeout(timer); deck.classList.add('is-paused'); });
      deck.addEventListener('mouseleave', () => { paused = false; deck.classList.remove('is-paused'); restart(); });

      /* ── Touch / Finger swipe & mouse drag slider ── */
      const stack = $('[data-wo-deck-stack]', deck);
      if (stack && n > 1) {
        let startX = 0, startY = 0, currentX = 0, isDragging = false, isHorizontal = null, startTime = 0;
        let dragCard = null, clickBlocked = false;

        const suppressClick = () => {
          clickBlocked = true;
          setTimeout(() => { clickBlocked = false; }, 320);
        };

        stack.addEventListener('click', e => {
          if (clickBlocked) {
            e.preventDefault();
            e.stopPropagation();
          }
        }, true);

        const onTouchStart = (clientX, clientY) => {
          startX = clientX;
          startY = clientY;
          currentX = clientX;
          isDragging = true;
          isHorizontal = null;
          startTime = Date.now();
          dragCard = cards[cur];
          clearTimeout(timer);
        };

        const onTouchMove = (clientX, clientY, e) => {
          if (!isDragging || !dragCard) return;
          const dx = clientX - startX;
          const dy = clientY - startY;

          if (isHorizontal === null) {
            if (Math.abs(dx) > 7 || Math.abs(dy) > 7) {
              isHorizontal = Math.abs(dx) >= Math.abs(dy);
            }
          }

          if (isHorizontal) {
            if (e && e.cancelable) e.preventDefault();
            currentX = clientX;
            // Drag feedback with slight resistance
            const boundedDx = dx * 0.92;
            dragCard.style.transition = 'none';
            dragCard.style.transform = `translateX(${boundedDx}px)`;
          }
        };

        const onTouchEnd = (e) => {
          if (!isDragging) return;
          isDragging = false;
          const dx = currentX - startX;
          const duration = Date.now() - startTime;
          const threshold = 40;
          const quickFlick = Math.abs(dx) > 20 && duration < 260;

          if (dragCard) {
            dragCard.style.transition = '';
            dragCard.style.transform = '';
          }

          if (isHorizontal && (Math.abs(dx) > threshold || quickFlick)) {
            suppressClick();
            if (e && e.cancelable) e.preventDefault();
            const dir = dx < 0 ? 1 : -1;
            go(cur + dir, dir);
          } else {
            restart();
          }

          isHorizontal = null;
          dragCard = null;
        };

        // Touch event listeners for mobile finger swipe
        stack.addEventListener('touchstart', e => {
          if (!e.touches || !e.touches[0]) return;
          if (e.target && e.target.closest('[data-wo-deck-bars], [data-wo-deck-next], [data-wo-deck-prev]')) return;
          onTouchStart(e.touches[0].clientX, e.touches[0].clientY);
        }, { passive: true });

        stack.addEventListener('touchmove', e => {
          if (!e.touches || !e.touches[0]) return;
          onTouchMove(e.touches[0].clientX, e.touches[0].clientY, e);
        }, { passive: false });

        stack.addEventListener('touchend', e => {
          onTouchEnd(e);
        });

        stack.addEventListener('touchcancel', () => {
          if (dragCard) {
            dragCard.style.transition = '';
            dragCard.style.transform = '';
          }
          isDragging = false;
          isHorizontal = null;
          restart();
        });

        // Pointer / mouse drag support
        stack.addEventListener('mousedown', e => {
          if (e.button !== 0) return;
          if (e.target && e.target.closest('[data-wo-deck-bars], [data-wo-deck-next], [data-wo-deck-prev]')) return;
          onTouchStart(e.clientX, e.clientY);
          const onDocMouseMove = ev => onTouchMove(ev.clientX, ev.clientY, ev);
          const onDocMouseUp = ev => {
            document.removeEventListener('mousemove', onDocMouseMove);
            document.removeEventListener('mouseup', onDocMouseUp);
            onTouchEnd(ev);
          };
          document.addEventListener('mousemove', onDocMouseMove);
          document.addEventListener('mouseup', onDocMouseUp);
        });
      }
      paint(); restart();
    });
  }

  /* ── Conveyor belts: loop tags endlessly, fill wide screens ───────────── */
  function initBelts() {
    $$('[data-wo-belt]').forEach(belt => {
      const items = $$(':scope > .wo-tag', belt); if (!items.length) return;
      const set = document.createElement('div'); set.className = 'wo-belt__set';
      items.forEach(it => set.appendChild(it));
      const tagW = innerWidth <= 560 ? 175 : 298, need = Math.max(1400, innerWidth + 300);
      let est = items.length * tagW;
      while (est < need) {
        items.forEach(it => { const c = it.cloneNode(true); c.setAttribute('aria-hidden', 'true'); $$('a,button', c).forEach(el => el.tabIndex = -1); set.appendChild(c); });
        est += items.length * tagW;
      }
      const clone = set.cloneNode(true); clone.setAttribute('aria-hidden', 'true');
      $$('a,button', clone).forEach(el => el.tabIndex = -1);
      const row = document.createElement('div'); row.className = 'wo-belt__row';
      const secPerTag = parseFloat(belt.dataset.speed || '4.2');
      row.style.setProperty('--wo-belt-dur', set.children.length * secPerTag + 's');
      row.append(set, clone); belt.append(row);
      belt.addEventListener('touchstart', () => belt.classList.add('is-paused'), { passive: true });
      belt.addEventListener('touchend', () => setTimeout(() => belt.classList.remove('is-paused'), 2500), { passive: true });
      belt.addEventListener('focusin', () => belt.classList.add('is-paused'));
      belt.addEventListener('focusout', () => belt.classList.remove('is-paused'));
    });
  }

  /* ── Postcards: tap / Enter to flip ────────────────────────────────────── */
  function initPostcards() {
    $$('.wo-flip').forEach(c => {
      c.addEventListener('click', e => { if (!e.target.closest('a,button')) c.classList.toggle('is-flipped'); });
      c.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { if (e.target !== c) return; e.preventDefault(); c.classList.toggle('is-flipped'); } });
    });
  }

  /* ── Toast ─────────────────────────────────────────────────────────────── */
  let toastTimer;
  function toast(msg) {
    const t = $('[data-wo-toast]'); if (!t) return;
    t.textContent = msg; t.classList.add('is-shown');
    clearTimeout(toastTimer); toastTimer = setTimeout(() => t.classList.remove('is-shown'), 2400);
  }

  /* ── Cart drawer (Shopify AJAX Cart API) ───────────────────────────────── */
  const Cart = {
    drawer: null,
    open() { document.documentElement.classList.add('wo-cart-open'); this.drawer?.setAttribute('aria-hidden', 'false'); $('[data-wo-cart-close]')?.focus(); },
    close() { document.documentElement.classList.remove('wo-cart-open'); this.drawer?.setAttribute('aria-hidden', 'true'); },
    async fetch() { const r = await fetch(routes.cart, { headers: { Accept: 'application/json' } }); return r.json(); },
    async add(id, quantity = 1) {
      const r = await fetch(routes.add, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: +id, quantity: +quantity }] }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not add to cart');
      return data.items ? data.items[0] : data;
    },
    async change(key, quantity) {
      const r = await fetch(routes.change, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity }) });
      const data = await r.json();
      if (!r.ok) throw new Error(data.description || data.message || 'Could not update cart');
      return data;
    },
    render(cart) {
      $$('[data-wo-cart-count]').forEach(el => el.textContent = cart.item_count || 0);

      // Realtime sync of all on-page quantity selectors with cart state
      const variantQuantities = {};
      if (cart && Array.isArray(cart.items)) {
        for (const it of cart.items) {
          const vid = String(it.variant_id || it.id);
          variantQuantities[vid] = (variantQuantities[vid] || 0) + it.quantity;
        }
      }
      $$('[data-wo-wrap]').forEach(wrap => {
        const vid = String(wrap.dataset.woWrap);
        const qty = variantQuantities[vid] || 0;
        wrap.classList.toggle('is-in-cart', qty > 0);
        const countEl = $('[data-wo-qty-count]', wrap);
        if (countEl) countEl.textContent = Math.max(1, qty);
      });

      const body = $('[data-wo-cart-body]'), foot = $('[data-wo-cart-foot]'), tpl = $('[data-wo-cart-empty-tpl]');
      if (!body) return;
      if (!cart.item_count) { body.innerHTML = tpl ? tpl.innerHTML : ''; if (foot) foot.hidden = true; return; }
      const esc = s => String(s).replace(/[&<>"]/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
      let compare = 0;
      body.innerHTML = cart.items.map(it => {
        const orig = (it.variant_compare_at_price || it.compare_at_price || 0) * it.quantity;
        compare += Math.max(orig, it.final_line_price);
        const img = it.featured_image && it.featured_image.url ? `<img src="${esc(it.featured_image.url)}&width=160" alt="" loading="lazy">` : '';
        const meta = [it.product_type, it.variant_title].filter(Boolean).map(esc).join(' · ');
        return `<div class="wo-line">
          <a class="wo-line__img" href="${esc(it.url)}">${img}</a>
          <div><a class="wo-line__name" href="${esc(it.url)}">${esc(it.product_title)}</a><div class="wo-line__meta">${meta}</div>
            <div class="wo-qty" data-key="${esc(it.key)}"><button type="button" data-d="-1" aria-label="Decrease quantity">−</button><span>${it.quantity}</span><button type="button" data-d="1" aria-label="Increase quantity">+</button></div></div>
          <div class="wo-line__price">${money(it.final_line_price, cart.currency)}${orig > it.final_line_price ? `<s>${money(orig, cart.currency)}</s>` : ''}</div>
        </div>`;
      }).join('');
      if (foot) {
        foot.hidden = false;
        const save = compare - cart.total_price;
        $('[data-wo-cart-mrp]', foot).textContent = money(compare, cart.currency);
        $('[data-wo-cart-save]', foot).textContent = '−' + money(save, cart.currency);
        $$('[data-wo-cart-hasave]', foot).forEach(el => el.hidden = save <= 0);
        $('[data-wo-cart-total]', foot).textContent = money(cart.total_price, cart.currency);
      }
    },
    async refresh() { this.render(await this.fetch()); },
    init() {
      this.drawer = $('[data-wo-cart]');
      $$('[data-wo-cart-open]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); this.open(); }));
      $$('[data-wo-cart-close]').forEach(b => b.addEventListener('click', () => this.close()));
      addEventListener('keydown', e => { if (e.key === 'Escape') this.close(); });
      $('[data-wo-cart-body]')?.addEventListener('click', async e => {
        const b = e.target.closest('[data-d]'); if (!b) return;
        const q = b.closest('.wo-qty'); const now = +$('span', q).textContent + +b.dataset.d;
        this.drawer.classList.add('is-busy');
        try { this.render(await this.change(q.dataset.key, Math.max(0, now))); } finally { this.drawer.classList.remove('is-busy'); }
      });
      $('[data-wo-cart-shop]')?.addEventListener('click', () => this.close());
      this.refresh();
    }
  };

  async function addToCart(variantId, qty = 1, name = '', btn = null, openDrawer = false) {
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    try {
      await Cart.add(variantId, qty);
      await Cart.refresh();
      toast((name ? name + ' — ' : '') + (CFG.strings?.added || 'boarding confirmed'));
      if (openDrawer) Cart.open();
    } catch (err) {
      toast(err.message);
      await Cart.refresh();
    } finally {
      if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    }
  }

  /* Realtime boarding & quantity selectors (belts, cards, postcards, sticky bar) */
  function initAddButtons() {
    // 1. Initial "BOARD ->" click
    document.addEventListener('click', e => {
      const b = e.target.closest('[data-wo-add]'); if (!b) return;
      e.preventDefault();
      const variantId = b.dataset.woAdd;
      const qtyInput = b.dataset.qtyFrom ? $(b.dataset.qtyFrom) : null;
      const qty = qtyInput ? (+qtyInput.value || 1) : 1;
      const name = b.dataset.name || '';

      // Optimistically flip all card buttons for this variant to quantity selector
      $$(`[data-wo-wrap="${variantId}"]`).forEach(wrap => {
        wrap.classList.add('is-in-cart');
        const countEl = $('[data-wo-qty-count]', wrap);
        if (countEl) countEl.textContent = qty;
      });

      addToCart(variantId, qty, name, b, false);
    });

    // 2. Realtime [ - / + ] delta click on product card
    document.addEventListener('click', async e => {
      const deltaBtn = e.target.closest('[data-wo-qty-delta]'); if (!deltaBtn) return;
      e.preventDefault();
      e.stopPropagation();

      const wrap = deltaBtn.closest('[data-wo-wrap]'); if (!wrap) return;
      const variantId = wrap.dataset.woWrap; if (!variantId) return;
      const delta = parseInt(deltaBtn.dataset.woQtyDelta, 10); if (isNaN(delta)) return;

      const countEl = $('[data-wo-qty-count]', wrap);
      const currentQty = parseInt(countEl ? countEl.textContent : '1', 10) || 1;
      const nextQty = Math.max(0, currentQty + delta);
      const name = wrap.dataset.name || '';

      // Optimistically update all instances on the page
      $$(`[data-wo-wrap="${variantId}"]`).forEach(w => {
        w.classList.toggle('is-in-cart', nextQty > 0);
        const c = $('[data-wo-qty-count]', w);
        if (c) c.textContent = Math.max(1, nextQty);
      });

      const buttons = $$(`[data-wo-wrap="${variantId}"] [data-wo-qty-delta]`);
      buttons.forEach(btn => btn.disabled = true);

      try {
        const cart = await Cart.change(variantId, nextQty);
        Cart.render(cart);
        if (nextQty === 0) {
          toast((name ? name + ' — ' : '') + 'removed');
        }
      } catch (err) {
        toast(err.message || 'Could not update cart');
        await Cart.refresh();
      } finally {
        buttons.forEach(btn => btn.disabled = false);
      }
    });
  }

  /* ── Product page form (works without JS as a normal /cart/add POST) ───── */
  function initProductForm() {
    $$('[data-wo-product-form]').forEach(form => {
      const qty = $('input[name="quantity"]', form);
      $$('[data-wo-qty-step]', form).forEach(b => b.addEventListener('click', () => {
        qty.value = Math.max(1, Math.min(99, (+qty.value || 1) + +b.dataset.woQtyStep));
      }));
      form.addEventListener('submit', e => {
        e.preventDefault();
        addToCart($('input[name="id"]', form).value, qty ? qty.value : 1, form.dataset.name, $('[type="submit"]', form), true);
      });
    });
  }

  /* ── Sticky "Board" bar on phones once the main button scrolls away ───── */
  function initSticky() {
    const bar = $('[data-wo-sticky]'), anchor = $('[data-wo-sticky-anchor]');
    if (!bar || !anchor) return;
    new IntersectionObserver(([e]) => bar.classList.toggle('is-shown', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(anchor);
  }

  /* ── Collection sort select ────────────────────────────────────────────── */
  function initSort() {
    $$('[data-wo-sort]').forEach(sel => sel.addEventListener('change', () => {
      const u = new URL(location.href); u.searchParams.set('sort_by', sel.value); u.searchParams.delete('page'); location.href = u.toString();
    }));
  }

  /* ── Product Card, Tag & Stage Image Sliders ─────────────────────────── */
  function initSliders() {
    function setSlide(slider, nextIdx) {
      const slides = $$('.wo-slider__slide, .wo-pdp-slider__slide', slider);
      const dots = $$('.wo-slider__dot', slider);
      const countEl = $('[data-slider-current]', slider);
      const n = slides.length;
      if (!n) return;
      const curIdx = (nextIdx + n) % n;

      slides.forEach((s, i) => {
        s.classList.toggle('is-active', i === curIdx);
        s.setAttribute('aria-hidden', i !== curIdx);
      });
      dots.forEach((d, i) => {
        d.classList.toggle('is-active', i === curIdx);
      });
      if (countEl) countEl.textContent = curIdx + 1;
      slider.dataset.activeSlide = curIdx;
    }

    document.addEventListener('click', e => {
      const btn = e.target.closest('[data-slider-prev], [data-slider-next], [data-slide-to]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      const slider = btn.closest('[data-wo-slider]');
      if (!slider) return;

      const slides = $$('.wo-slider__slide, .wo-pdp-slider__slide', slider);
      const n = slides.length;
      if (!n) return;

      let cur = +slider.dataset.activeSlide;
      if (isNaN(cur)) {
        const active = $('.is-active', slider);
        cur = active ? slides.indexOf(active) : 0;
      }

      if (btn.hasAttribute('data-slider-prev')) {
        setSlide(slider, cur - 1);
      } else if (btn.hasAttribute('data-slider-next')) {
        setSlide(slider, cur + 1);
      } else if (btn.hasAttribute('data-slide-to')) {
        setSlide(slider, +btn.dataset.slideTo);
      }
    });

    let startX = 0, startY = 0, activeSlider = null, hasSwiped = false;

    document.addEventListener('touchstart', e => {
      const slider = e.target.closest('[data-wo-slider]');
      if (!slider) return;
      activeSlider = slider;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      hasSwiped = false;
    }, { passive: true });

    document.addEventListener('touchmove', e => {
      if (!activeSlider) return;
      const dx = e.touches[0].clientX - startX;
      const dy = e.touches[0].clientY - startY;
      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        hasSwiped = true;
      }
    }, { passive: true });

    document.addEventListener('touchend', e => {
      if (!activeSlider || !hasSwiped) {
        activeSlider = null;
        return;
      }
      const dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 30) {
        const slides = $$('.wo-slider__slide, .wo-pdp-slider__slide', activeSlider);
        let cur = +activeSlider.dataset.activeSlide;
        if (isNaN(cur)) {
          const active = $('.is-active', activeSlider);
          cur = active ? slides.indexOf(active) : 0;
        }
        setSlide(activeSlider, cur + (dx < 0 ? 1 : -1));
      }
      setTimeout(() => { hasSwiped = false; }, 80);
      activeSlider = null;
    }, { passive: true });

    document.addEventListener('click', e => {
      if (hasSwiped && e.target.closest('[data-wo-slider]')) {
        e.preventDefault();
        e.stopPropagation();
      }
    }, true);
  }

  /* ── Header search with live predictive suggestions ──────────────────── */
  function initSearch() {
    const searchWrapper = $('[data-wo-search]');
    if (!searchWrapper) return;

    const input = $('[data-search-input]', searchWrapper);
    const clearBtn = $('[data-search-clear]', searchWrapper);
    const dropdown = $('[data-search-dropdown]', searchWrapper);
    const resultsContainer = $('[data-search-results]', searchWrapper);
    if (!input || !dropdown || !resultsContainer) return;

    let debounceTimer = null;
    let selectedIndex = -1;

    function formatMoney(amount) {
      if (!amount) return '';
      return '₹' + parseFloat(amount).toFixed(0);
    }

    async function fetchSuggestions(term) {
      if (!term || term.length < 2) {
        dropdown.hidden = true;
        resultsContainer.innerHTML = '';
        selectedIndex = -1;
        return;
      }

      try {
        const res = await fetch(`/search/suggest.json?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=5`);
        if (!res.ok) throw new Error('Search request failed');
        const data = await res.json();
        const products = data.resources?.results?.products || [];

        if (products.length === 0) {
          resultsContainer.innerHTML = `<div class="wo-search__empty">No departures found for "${term}"</div>`;
        } else {
          let html = products.map(p => `
            <a href="${p.url}" class="wo-search__item" data-search-item>
              ${p.image ? `<img src="${p.image}" alt="${p.title}" class="wo-search__thumb" width="36" height="36" loading="lazy">` : '<div class="wo-search__thumb"></div>'}
              <div class="wo-search__info">
                <span class="wo-search__title">${p.title}</span>
                <span class="wo-search__price">${formatMoney(p.price)}</span>
              </div>
            </a>
          `).join('');

          html += `
            <a href="/search?q=${encodeURIComponent(term)}&type=product" class="wo-search__all-btn">
              View all results for "${term}" →
            </a>
          `;

          resultsContainer.innerHTML = html;
        }

        dropdown.hidden = false;
        selectedIndex = -1;
      } catch (err) {
        console.error('Suggest search error:', err);
      }
    }

    input.addEventListener('input', e => {
      const val = e.target.value.trim();
      if (clearBtn) clearBtn.hidden = val.length === 0;

      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(() => {
        fetchSuggestions(val);
      }, 250);
    });

    input.addEventListener('focus', () => {
      searchWrapper.classList.add('is-focused');
      const val = input.value.trim();
      if (val.length >= 2) {
        fetchSuggestions(val);
      }
    });

    if (clearBtn) {
      clearBtn.addEventListener('click', () => {
        input.value = '';
        clearBtn.hidden = true;
        dropdown.hidden = true;
        resultsContainer.innerHTML = '';
        input.focus();
      });
    }

    // Keyboard navigation
    input.addEventListener('keydown', e => {
      if (dropdown.hidden) return;
      const items = $$('[data-search-item]', dropdown);
      if (items.length === 0) return;

      if (e.key === 'ArrowDown') {
        e.preventDefault();
        selectedIndex = (selectedIndex + 1) % items.length;
        items.forEach((it, idx) => it.classList.toggle('is-selected', idx === selectedIndex));
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        selectedIndex = (selectedIndex - 1 + items.length) % items.length;
        items.forEach((it, idx) => it.classList.toggle('is-selected', idx === selectedIndex));
      } else if (e.key === 'Enter' && selectedIndex >= 0) {
        e.preventDefault();
        items[selectedIndex]?.click();
      } else if (e.key === 'Escape') {
        dropdown.hidden = true;
      }
    });

    // Close dropdown on click outside
    document.addEventListener('click', e => {
      if (!searchWrapper.contains(e.target)) {
        dropdown.hidden = true;
        searchWrapper.classList.remove('is-focused');
      }
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initTheme(); initProgress(); initFlapboards(); initDecks(); initBelts(); initPostcards();
    Cart.init(); initAddButtons(); initProductForm(); initSticky(); initSort(); initSliders();
    initSearch();
    window.WayOut = Object.assign(window.WayOut || {}, { cart: Cart, toast });
  });
})();